import MakeNewLeadModal from './MakeNewLeadModal.component';

export default MakeNewLeadModal;